import { render, staticRenderFns } from "./WatsAppReport.vue?vue&type=template&id=0113f959&"
import script from "./WatsAppReport.vue?vue&type=script&lang=js&"
export * from "./WatsAppReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports